export default __webpack_public_path__ + "static/media/add-redIcon.e1246577.svg";